import { LanguageType } from '../index.js'
import {
  humberOfHomesTranslation,
  initiativeCreationStepDescriptionTranslation,
  initiativeCreationStepTitleTranslation,
  initiativePhaseDescriptionTranslation,
  initiativePhaseNameTranslation,
  initiativeUserRoleTranslation,
  notificationFrequencyTranslation,
  phaseTranslations,
  plotApplicationStatusesTranslations,
} from './en.enumTranslations.js'

const shared = {
  ambassador: 'Ambassador',
  crowdBuilding: 'CrowdBuilding',
  contactUsLink: 'Contact',
  knowledgeHub: 'Knowledge Hub',
  storiesLink: 'Stories',
  initiative: {
    singular: 'Initiative',
    plural: 'Initiatives',
  },
  location: {
    singular: 'Location',
    plural: 'Locations',
  },
  housingForms: 'Living formats',
  sendMessage: 'Send message',
  back: 'Back',
  yes: 'Yes',
  no: 'No',
  noPreference: 'No preference',
  external: 'External',
  messages: 'Messages',
  purchaseBudget: 'Purchase budget',
  rentalBudget: 'Rental budget',
  loading: 'Loading...',
  unknownLocation: 'Unknown location',
  unknown: 'Unknown',
  notSpecified: 'Not Specified',
  members: 'Members',
  followers: 'Followers',
  follow: 'Follow',
  following: 'Following',
  admins: 'Admins',
  followTooltip: 'Follow for updates',
  signUp: 'Sign up',
  lockedPageFollowed: 'You are following this page',
  lockedPageFollowedText:
    'Once it goes live you will be among the first people who will get notified.',
  attention: 'Attention',
}

// TODO: Ask LLM to do English here
const en: LanguageType = {
  app: {
    badges: {
      initiativeTaker: 'Initiative taker',
    },
    blogPage: {
      title: 'Latest',
      loading: shared.loading,
      tabs: {
        stories: 'Stories',
        news: 'News',
        blog: 'Blog',
      },
      noContent: 'No content found',
    },
    businessProfilePage: {
      address: 'Address',
      email: 'E-mail',
      phone: 'Phone number',
      website: 'Website',
      specializations: 'Specialised in',
    },
    common: {
      yes: 'Yes',
      no: 'No',
      other: 'Other',
      cancel: 'Cancel',
      save: 'Save',
      back: 'Back',
      continue: 'Continue',
      attention: shared.attention,
      note: 'Note:',
      seeMore: 'See all',
      hide: 'Hide',
      readMore: 'Read more',
      unknownLocation: shared.unknownLocation,
      initiative: {
        singular: 'Initiative',
        plural: 'Initiatives',
      },
      share: 'Share',
      follow: 'Follow',
      followTooltip: shared.followTooltip,
      unfollow: 'Unfollow',
      following: shared.following,
      contact: 'Contact',
      followers: 'Followers',
      followersAmount: '{0} followers',
      notSpecified: shared.notSpecified,
      initiativePhases: phaseTranslations,
      initiativeStatus: {
        searchingForMembers: 'Looking for members',
        notSearchingForMembers: 'Not looking for members',
      },
      plotApplicationStatus: plotApplicationStatusesTranslations,
      initiativeUserRole: initiativeUserRoleTranslation,
      loading: shared.loading,
      more: 'More',
      less: 'Less',
      location: 'Location',
      locationNotFoundMessage: 'Location not found',
      region: 'Region',
      regionNotFoundMessage: 'Region not found',
      toastSuccess: 'Success!',
      toastFailure: 'Something went wrong',
      genericToastFailureMessage:
        'Please, try again. If problem persists contact CrowdBuilding.',
      sendMessage: shared.sendMessage,
      unknown: shared.unknown,
      noItems: 'No items found',
      filtersTooltip: 'Filters',
      signUp: shared.signUp,
    },
    auth: {
      logIn: 'Log in',
      signUp: shared.signUp,
      logInTitle: 'Welcome back!',
      signUpTitle: 'Sign up with CrowdBuilding',
      signUpSubtitle: 'Sign up for free.',
      shareMoreTitle: 'Share something about yourself',
      shareMoreSubtitle:
        'This will help you find people and initiatives that suit you more quickly.',
      email: 'Email',
      emailPlaceholder: 'Fill in your email address...',
      emailSubtitle:
        'You will receive a confirmation code at this email address to log in.',
      privacySubtitle: 'By signing up you agree to our',
      privacySubtitleAnd: 'and',
      privacyStatementLink: 'privacy statement',
      termsAndConditionsLink: 'general terms and conditions',
      privacyStatementTitle: 'CrowdBuilding Privacy Statement',
      termsAndConditionsTitle: 'General Terms and Conditions',
      firstName: 'First name',
      firstNamePlaceholder: 'First name',
      lastName: 'Last name',
      lastNamePlaceholder: 'Last name',
      placeOfResidence: 'Place of residence',
      ageCategory: 'Age category',
      ageCategoryPlaceholder: 'Choose one...',
      searchRegion: 'Search region',
      searchRegionPlaceholder: 'Where would you like to live?',
      continueWithGoogle: 'Continue with Google',
      continueWithApple: 'Continue with Apple',
      loginButton: 'Log in',
      signUpButton: 'Create an account',
      verificationCodeBanner:
        'You have received a verification code in your email',
      verificationLabel: 'Verification code',
      emailInvalidMessage: 'Check your email and try again.',
      emailIssueNoUserMessage: 'User with this email does not exist',
      emailIssueUserExistsMessage: 'User with this email already exists',
      emailIssueOtherMessage: 'Something went wrong',
      otcIssueMessage:
        'Incorrect 2FA code. Please try again or request a new code.',
      nameInvalidMessage: 'Cannot be empty',
      otherIssueMessage: 'Something went wrong. Please, try again.',
      sendCodeAgain: 'Send code again',
      alreadyLoggedIn: 'You are already logeed in.',
    },
    discoveryPage: {
      initiatives: 'Initiatives',
      plots: 'Locations',
      regions: 'Regions',
      housingForms: 'Living formats',
      searchResults: {
        singular: 'result',
        plural: 'results',
      },
      searchPlaceholder: {
        mobile: 'Search',
        initiatives: 'Search by name, municipality or province',
        plots: 'Search by name, municipality or province',
        regions: 'Search by name of your town, municipality or province',
        housingForms: 'Search by keyword',
      },
      searchSuggestions: {
        locality: 'Place in {0}',
        municipality: 'Municipality in {0}',
        region: 'Province in {0}',
      },
      filterDrawer: {
        title: 'Filters',
        phase: 'Phase',
        applicationStatus: 'Phase',
        lookingForMembers: 'Looking for members',
        developmentForm: 'Development form',
        province: 'Province',
        applicationType: 'Application type',
        apply: 'Apply',
        back: 'Back',
        initiativePhases: phaseTranslations,
        plotApplicationStatuses: plotApplicationStatusesTranslations,
        yes: 'Yes',
        no: 'No',
        noPreference: 'No preference',
        external: 'External',
        crowdBuilding: 'CrowdBuilding',
        externalTooltip: 'Initiatives that are made by external websites.',
        crowdBuildingTooltip: 'Initiatives that are made by CrowdBuilding.',
      },
      tabs: {
        initiatives: {
          title: 'Discover initiatives',
          subTitle: 'Find your dream home here.',
        },
        plots: {
          title: 'Discover locaties',
          subTitle: 'Find your dream home here.',
          mapTitle: {
            singular: 'There is {0} initiative',
            plural: 'There are {0} initiatives',
          },
        },
        regions: {
          provinceTitle: 'Discover regios',
          provinceSubTitle:
            'Learn how your province can help you yo realize your dream.',
          municipalitesTitle: 'All municipalities',
          municipalitesSubtitle:
            'Discover what is happening in the field of building and living together.',
          featuredMunicipalitesTitle: 'Featured',
          featuredMunicipalitesSubtitle:
            'View the latest news, policy, initiatives and locations in these popular municipalities.',
        },
        housingForms: {
          subtitle:
            'Discover different themes within collective building and living.',
        },
      },
    },
    housingFormPage: {
      loading: shared.loading,
      follow: shared.follow,
      following: shared.following,
      ambassador: shared.ambassador,
      ambassadorCard: {
        title: 'Ambassador',
      },
      popularHousingFormsCard: {
        title: 'Popular housing forms',
      },
      tabs: {
        overview: 'Overview',
        thread: 'Discussion',
        initiatives: 'Initiatives',
        plots: 'Locations',
        popularHousingForms: 'Popular housing forms',
      },
    },
    topicCommunityPage: {
      loading: shared.loading,
      follow: shared.follow,
      following: shared.following,
      managedBy: 'Managed by',
      featuredInitiatives: 'Featured initiatives',
      noKnowledgeHubModules: 'No knowledge modules linked.',
      relatedHousingFormsCard: {
        title: 'Housing forms',
      },
      networksCard: {
        title: 'Networks',
      },
      tabs: {
        overview: 'Overview',
        thread: 'Discussion',
        initiatives: 'Initiatives',
        knowledgeHub: 'Knowledge hub',
        contactInfo: 'Contact',
        events: 'Agenda',
      },
      noContact: 'No contact information available.',
      noEvents: 'No events linked.',
      municipality: 'Municipality',
      knowledgeBank: 'Knowledge bank',
      knowledgeHub: shared.knowledgeHub,
    },
    legalPage: {
      title: 'Legal Documents',
      termsAndConditionsDownloadTitle: 'Terms and Conditions',
      privacyPolicyDownloadTitle: 'Privacy Policy',
      cookiePolicyDownloadTitle: 'Cookie Policy',
      downloadButtonLabel: 'Download PDF',
    },
    regionCard: {
      initiatives: {
        singular: 'initiative',
        plural: 'initiatives',
      },
      subsidies: {
        singular: 'subsidy',
        plural: 'subsidies',
      },
      plots: {
        singular: 'kavel',
        plural: 'kavels',
      },
    },
    knowledgeHubPage: {
      title: 'Knowledge Hub',
      loading: 'Loading...',
      menu: 'Knowledge Hub Menu',
      searchPlaceholder: 'Search',
      noResults: 'No results found',
      back: shared.back,
    },
    elearningPage: {
      sidebarTitle: 'Curriculum',
      searchPlaceholder: 'Search',
      title: 'Learning environment',
      loading: 'Loading...',
      menu: 'Learning environment Menu',
      previous: 'Previous',
      next: 'Next',
      selectItem: 'Select an item from the menu',
      viewSlides: 'View the slides',
      viewSlidesDesc:
        'Do you want to view the presentation again at your own pace? View the slideshow below. You can also download and print the presentation.',
      assignments: 'Assignments for the modules',
      assignmentsDesc1:
        'At the end of each module you can download an assignment form. It contains questions for you and an assignment that you do together with your group.',
      assignmentsDesc2:
        'The questions you fill in yourself are intended to organize your own thoughts. Then you can discuss your vision and your housing dream well prepared with other group members. This way you come a step closer to a concrete plan for your initiative every module.',
      tip: 'Tip: Stichting !WOON regularly organizes in-depth training courses to develop your vision, mission, plan of approach and financial business plan in group form. Do you want to know more about this? Check our agenda for these training courses.',
      downloadPdfLabel: 'Download PDF',
    },
    landingPage: {
      title: 'Make your living dream a reality.',
      description:
        'Housing construction needs to be radically different. More sustainable, more social, and more affordable. Build together with your future neighbours.',
      searchPlaceholder: 'Search by name, municipality or province',
      searchButton: 'Search',
      modernAFrameHouse: 'Modern A-frame House',
      erfdelen: 'Erfdelen',
      sharedLivingSpacesAndCommunityPlots:
        'Shared living spaces and community plots',
      meergeneratiewonen: 'Meergeneratiewonen',
      multiGenerationalLivingCommunities:
        'Multi-generational living communities',
      whyCrowdBuilding: 'Why CrowdBuilding?',
      whyCrowdBuildingDescription:
        'Housing construction must be radically different: more sustainable, social and affordable. By building together with your future neighbors, you determine how you live, save costs and create a close-knit community.',
      signUpButton: 'Sign up',
      maintenanceMessage:
        'We are currently performing maintenance on our platform. Please check back shortly.',

      discoverSection: {
        title: 'Initiatives',
        subTitle:
          'Find or start an initiative that fits your housing dream and get in touch with others.',
        seeMore: 'See all',
      },
      housingFormsSection: {
        title: 'Popular living formats',
        subTitle:
          'How do you want to live? In a tiny house? Or is the region important to you? Find each other.',
        seeMore: 'See all',
      },
      aboutSection: {
        title: 'About CrowdBuilding',
        subTitle:
          'Collective building and living is realizing your ideal living place together with others. Design and build your own living environment together with a group, or find your place in an existing community. It can all be done. But how do you start? Read more in our KnowledgeHub.',
        seeMore: 'Read more',
        cta: [
          {
            title: 'Find others',
            subtitle:
              'Find or start an initiative and get in touch with each other.',
          },
          {
            title: 'Find a location',
            subtitle:
              'On CrowdBuilding you will find plots and buildings suitable for collective building projects.',
          },
          {
            title: 'Find experts',
            subtitle:
              'Find the right experts at every stage of your initiative. From architects to financing.',
          },
        ],
      },
      blogSection: {
        title: 'Stories',
        subTitle:
          'Many people have gone before you. Read how these collective builders approach it.',
        seeMore: 'See all',
      },
      statsAndCtaSection: {
        title: 'Every day new people and initiatives join. ',
        subTitle:
          'Every day people and initiatives take the next step towards realising their housing dream. Sign up for free and start today.',
        cta: [
          {
            title: 'Start an initiative',
          },
          {
            title: 'Sign up',
          },
        ],
        statistics: [
          {
            number: '8K+',
            subtitle: 'Users',
          },
          {
            number: '95+',
            subtitle: 'Locations',
          },
          {
            number: '170+',
            subtitle: 'Initiatives',
          },
          {
            number: '65+',
            subtitle: 'Experts',
          },
        ],
      },
      newsletterSection: {
        title: 'Sign up',
        subTitle: 'Start your housing dream or find others.',
        placeholder: 'Email address',
        successMessage: 'Thanks for subscribing!',
      },
    },
    discoverServiceProviders: {
      title: 'Experts',
      description:
        'From architects to process supervisors and from financial advisors to local support points: find the right help for every phase of your self-build initiative.',
      filters: 'Filters',
      removeFilters: 'Remove Filters',
      searchPlaceholder: 'Search for experts',
      categories: {
        processSupervision: 'Process Supervision',
        architecture: 'Architecture',
        advice: 'Advice',
        financing: 'Financing',
        development: 'Development',
        construction: 'Construction',
        networks: 'Networks',
        supportPoint: 'Support Point',
      },
      filtersModal: {
        title: 'Filters',
        specialism: 'Specialism',
        operatingArea: 'Operating Area',
        apply: 'Apply',
      },
    },
    messageComposeModal: {
      newMessage: 'New message',
      recipient: 'To',
      subject: 'Subject',
      message: 'Message',
      send: 'Send message',
    },
    socialShareModal: {
      title: 'Share this page',
      email: 'Email',
      x: 'X',
      facebook: 'Facebook',
      whatsapp: 'WhatsApp',
      copyLink: 'Copy link',
      copiedLink: 'Link copied!',
      close: 'Close',
    },
    serviceProviderPage: {
      overview: 'Overview',
      events: 'Agenda',
      initiatives: 'Initiatives',
      ourInitiatives: 'Our initiatives',
      ourInitiativesDescription: 'Join one of our collective initiatives.',
      developmentArea: 'Development area',
      concepts: 'Concepts',
      ourConcepts: 'Our concepts',
      address: 'Address',
      email: 'Email',
      phone: 'Phone number',
      website: 'Website',
      specializations: 'Specialized in',
      activeRegions: 'Working area',
      loading: shared.loading,
      notFound: 'Expert not found',
    },
    serviceProviderConceptPage: {
      tabs: {
        overview: 'Overview',
        initiatives: shared.initiative.plural,
        discussions: 'Discussion',
      },
      offeredBy: 'Offered by',
      members: shared.members,
      loading: shared.loading,
      initiatives: shared.initiative.plural,
      initiativesDescription: 'Join one of the collective initiatives.',
    },
    footer: {
      slogan: 'The ultimate living place\nyou build together',
      info: 'Info',
      services: 'Services',
      joinIn: 'Join in',
      sections: {
        info: {
          howDoesItWork: 'How does it work?',
          contactUsLink: 'Contact us',
          knowledgeHub: 'Knowledge hub',
          storiesLink: 'Stories',
          blogAndNewsLink: 'Blog & News',
          events: 'Events',
          termsAndConditions: 'Terms and conditions',
          privacy: 'Privacy statement',
        },
        services: {
          initiatives: 'Initiatives',
          plots: 'Plots',
          housingForms: 'Living formats',
          experts: 'Experts',
          cpoDesks: 'CPO-desk in your region',
        },
        joinIn: {
          joinGroup: 'Register a group',
          applyForPlot: 'Apply for a plot',
          forExperts: 'For experts',
          forMunicipalities: 'For municipalities',
          joinUsLink: 'Work at CrowdBuilding',
        },
      },
    },
    mediaGallery: {
      allMedia: 'All media',
    },
    pageNames: {
      home: 'Home',
      initiatives: 'Initiatives',
      housingForms: 'Housing forms',
      plots: 'Plots',
      serviceProviders: 'Experts',
      regions: 'Regions',
    },
    initiativePage: {
      applyTooltip: 'Apply to join and get in touch',
      followTooltip: shared.followTooltip,
      membersTooltip: 'Online members of this initiative',
      unknownLocation: shared.unknownLocation,
      notSpecified: shared.notSpecified,
      apply: 'Apply to join',
      leave: 'Leave initiative',
      withdrawApplication: 'Withdraw application',
      follow: shared.follow,
      following: shared.following,
      share: 'Share',
      initiative: shared.initiative,
      follower: {
        singular: 'Follower',
        plural: 'Followers',
      },
      member: {
        singular: 'Member',
        plural: 'Members',
      },
      admin: {
        singular: 'Admin',
        plural: 'Admins',
      },
      overview: 'Overview',
      thread: 'Thread',
      overviewTab: {
        searchArea: 'Search area',
        features: 'Features',
        contact: 'Contact information',
      },
      phases: phaseTranslations,
      modalApplyConfirmation:
        'Are you sure you want to apply to be the member of initiative {0}? Initiative admin will review your application',
      modalLeaveConfirmation: 'Are you sure you want to leave initiative {0}?',
      modalWithdrawConfirmation:
        'Are you sure you want to withdraw your membership application to initiative {0}?',
      modalApplyTitle: 'Apply to join',
      modalDefaultTitle: shared.attention,
      overviewFeaturesKeys: {
        location: 'Location',
        phase: 'Initiative phase',
        developmentForm: 'Development form',
        numberOfHouseholds: 'Number of households',
        livingEnvironment: 'Living environment',
        targetAudience: 'Target audience',
        tags: 'Tags',
      },
      contactInformationKeys: {
        contactPerson: 'Contact person',
      },
    },
    plotPage: {
      deadline: 'Deadline',
      officialOffering: 'CrowdBuilding registration',
      privateOffering: 'External registration',
      applicationClosesInLabel: 'Application closes in {0}d',
      maxParticipantsLabel: 'Maximum homes {0}',
      applicationStatus: {
        applicationOpen: 'Application open',
        applicationClosed: 'Application closed',
        inPreparation: 'In preparation',
      },
      plotRegistryRequirementAlert:
        'Note! A {0} is required for this application.',
      plotRegistryRequirementAlertLinkText: 'plot registry registration',
      registerInitiative: 'Register initiative',
      follow: 'Interest list',
      share: 'Share',
      offeredBy: 'Offered by',
      initiative: {
        singular: 'Initiative',
        plural: 'Initiatives',
      },
      follower: {
        singular: 'Follower',
        plural: 'Followers',
      },
      interestListText: 'on the interest list',
      overview: 'Overview',
      applicationProcedure: 'Application procedure',
      documents: 'Documents',
      thread: 'Bulletin board',
      overviewTab: {
        info: 'Info',
        whatIsNext: "What's next",
        location: 'Location',
        plan: 'Planning',
        contact: 'Contact information',
        features: 'General',
      },
      overviewFeaturesKeys: {
        offerType: 'Offer type',
        buildingType: 'Building type',
        developmentForm: 'Development form',
        ownershipType: 'Ownership type',
        livingEnvironment: 'Living environment',
        numberOfUnits: 'Number of units',
      },
      contactInformationKeys: {
        providerType: 'Provider type',
        organization: 'Organization',
        contactPerson: 'Name',
        email: 'Email',
        website: 'Website',
      },
      threadTab: {
        postPlaceholder: 'Write your question here',
      },
      modalCopy: {
        official:
          'Your interest in this plot becomes visible to other CrowdBuilders. They can send you a message. This way you have a chance to form an initiative together for this application.',
        nonOfficial:
          'Your interest in this plot becomes visible to other CrowdBuilders. They can send you a message. This way you have a chance to form an initiative together for this application.\n\nThe official application runs through the website of the plot provider.',
      },
      followModal: {
        title: 'Sign up Interest list',
        prompt: 'Do you want to sign up as initiative or individual?',
        asInitiative: 'As initiative',
        asIndividual: 'As individual',
        selectInitiative: 'Select an initiative',
      },
      unfollowModal: {
        title: 'Unsubscribe Interest list',
        prompt: 'What would you like to unsubscribe?',
        asInitiative: 'Initiative',
        asIndividual: 'Individual',
        selectInitiative: 'Select initiatives to unsubscribe',
      },
      sendMessage: 'Send message',
    },
    post: {
      like: 'Like',
      reply: 'Reply',
      oneLike: 'Like',
      manyLikes: 'Likes',
      oneReply: 'Reply',
      manyReplies: 'Replies',
      typeYourReply: 'Type your reply',
      loadMoreReplies: 'Load more replies',
      loadMoreComments: 'Load more comments',
    },
    profilePage: {
      bio: 'Bio',
      livingDream: 'Living dream',
      media: 'Media',
      connect: 'Make contact',
      placeOfResidence: 'Place of residence',
      initiatives: 'Initiatives',
      followedHousingForms: 'Follows Living formats',
      searchRegion: 'Searches in region',
      livingEnvironment: 'Living environment',
      interests: 'Interests',
      emptyProfileMessage: 'has not introduced themselves yet.',
    },
    regionPage: {
      managedBy: 'Managed by',
      overview: 'Overview',
      discussion: 'Discussion',
      initiatives: 'Initiatives',
      initiativesIn: 'Initiatives in {0} ({1})',
      locationsIn: 'Locations in {0} ({1})',
      current: 'Current',
      developmentAreas: 'Development areas',
      stepByStep: 'Step by step',
      locations: 'Locations',
      subsidies: 'Subsidies',
      more: 'More',
      nutshell: {
        inAnutshell: ' in a nutshell',
      },
      events: 'Agenda',
      news: 'News',
      latestDiscussions: 'Latest Discussions',
      popularInitiatives: 'Popular Initiatives',
      popularHousingFormsIn: 'Popular living formats in',
      networksAndSupportGroupsIn: 'Networks and Support Groups in',
      topicCommunitiesIn: 'Organisations in',
      municipalities: 'Municipalities',
      lockedMunicipalityHeader: 'Municipality {0} is not yet online',
      lockedMunicipalityFollowed: shared.lockedPageFollowed,
      lockedMunicipalityBodyFollowed: shared.lockedPageFollowedText,
      lockedMunicipalityBody:
        'We are working to make this municipality available on CrowdBuilding. Show your interest and be the first to know when {0} goes online.',
      lockedProvinceHeader: 'Province {0} is not yet online',
      lockedProvinceFollowed: shared.lockedPageFollowed,
      lockedProvinceBodyFollowed: shared.lockedPageFollowedText,
      lockedProvinceBody:
        'We are working to make this province available on CrowdBuilding. Show your interest and be the first to know when {0} goes online.',
      followThePage: 'Follow the page',
      pageFollowed: 'Followed',
      sorting: {
        newestFirst: 'Newest first',
        oldestFirst: 'Oldest first',
        popular: 'Popular first',
      },
      filters: {
        title: 'Filters',
        phase: 'Phase',
        lookingForMembers: 'Looking for members',
        developmentForm: 'Development form',
        apply: 'Apply',
        back: 'Back',
        yes: 'Yes',
        no: 'No',
        noPreference: 'No preference',
      },
    },
    nav: {
      find: 'Find',
      findDescription: 'Find initiatives and living groups that fit you',
      start: 'Start',
      learn: 'Learn',
      aboutUs: 'About',
      logIn: 'Log in',
      signUp: 'Sign up',
      logOut: 'Log out',
      dashboardHome: 'Overview',
      profile: 'Profile',
      megaMenu: {
        findMenu: {
          initiatives: {
            label: 'Find initiatives',
            description: 'View collective self-build groups and join.',
          },
          livingGroups: {
            label: 'Find living groups',
            description: 'Find existing living groups looking for residents.',
          },
          plots: {
            label: 'Find locations',
            description:
              'Find plots or buildings to realize your living dream.',
          },
          region: {
            label: 'Search in your region',
            description: 'View initiatives, plots and get in touch.',
          },
          housingForms: {
            label: 'Find housing forms',
            description:
              'Tiny houses or self-build street? Follow your favorite housing forms.',
          },
          experts: {
            label: 'Find expert',
            description: 'From process supervisors to architects.',
          },
        },
        startMenu: {
          citizens: {
            label: 'For citizens',
            description:
              'Start a new initiative or register an existing initiative and find interested people.',
            links: {
              startInitiative: 'Start an initiative on CrowdBuilding',
              registerProject: 'Register existing project/housing group',
            },
          },
          companies: {
            label: 'For developers',
            description:
              'Are you a professional party looking for enthusiastic residents for a project? Start here.',
          },
        },
        learnMenu: {
          knowledgeHub: {
            label: 'Knowledge Hub',
            description:
              'Here you will find all the information you need to make your living dream a reality.',
            links: {
              whatCanIDo: 'What can I do on CrowdBuilding?',
              createAccount: 'How do I create an account?',
              startInitiative: 'How do I start an initiative myself?',
            },
          },
          elearning: {
            label: 'E-learning',
            description:
              'Learn step by step everything about collective self-building with our free e-learnings.',
          },
          stories: {
            label: 'Stories',
            description: 'Read how others successfully build together.',
          },
        },
        aboutUsMenu: {
          about: {
            label: 'About CrowdBuilding',
            description:
              'How we contribute to a fair and sustainable housing market.',
            links: {
              stewardOwned: 'Steward-owned',
              joinUs: 'Careers',
              contact: 'Contact',
            },
          },
          legal: {
            label: 'Legal',
            description: 'General terms and conditions and privacy policy.',
          },
          partner: {
            label: 'Become a Partner',
            links: {
              municipalities: 'Municipalities',
              provinces: 'Provinces',
              experts: 'Experts',
            },
          },
        },
        shared: {
          knowledgeHub: 'Knowledge Hub',
          howCrowdBuildingWorksLink: 'How does CrowdBuilding work?',
          howCrowdBuildingWorksDescription:
            'Join an initiative and form\na building group',
          whatIsCollectiveSelfConstruction: 'What is collective self-build?',
          isCollectiveLivingAffordable: 'Is collective living affordable?',
          storiesLink: 'Stories',
          storiesDescription:
            'Successfully building together?\nSee how they did it!',
          governmentSectionLink: 'Government desk',
          governmentSectionDescription:
            'View policy, building plots,\ninitiatives and subsidies per region.',
          relevantNow: 'Relevant now',
        },
      },
    },
    dashboard: {
      yourInitiatives: 'Your initiatives',
      noteworthyInitiatives: 'Noteworthy initiatives',
      nav: {
        home: 'Home',
        messages: 'Messages',
        initiatives: 'Initiatives',
        profile: 'Profile',
        preferences: 'Preferences',
        following: shared.following,
      },
      home: {
        title: 'Hello, {0}',
        welcome: 'Welcome to your dashboard',
        updatesPlaceholder:
          'From your dashboard you can manage your messages, initiatives and profile, and discover new initiatives.\nSoon you will also see updates from initiatives and pages you follow.',
        KnowledgeHub: 'Knowledge Hub',
        KnowledgeHubCardTitle: 'New here?',
        KnowledgeHubCardDescription: 'Learn more about collective building and living in our knowledge hub.',
        DiscoverMore: 'Discover',
        DiscoverCardTitle: 'Looking for a house?',
        DiscoverCardDescription: 'Find a living group looking for residents, or join an initiative that is still in the making.',
        StartInitiative: 'Start initiative',
        StartInitiativeCardTitle: 'Start your own initiative?',
        StartInitiativeCardDescription: 'Start your own initiative and find interested people, plots and more.',
        StoriesTitle: 'Let yourself be inspired by\n others',
      },
      messages: {
        messages: shared.messages,
        inbox: 'Inbox',
        openMessages: 'Open messages',
        peopleToMessageTitle: 'People to message',
        peopleToMessageDescription:
          "Note: you can only message to admins of the initiative you're following or are member of.",
        allMessages: 'All messages',
        followedInitiatives: 'Initiatives I follow',
        from: 'from',
        sendMessage: 'Send message',
        newMessage: 'New Message',
        subject: 'Subject:',
        typeYourReply: 'Type your reply...',
        noMessagesPlaceholder: 'No messages',
        emptyStateTitle: 'Your messages',
        emptyStateSubtitle:
          'Here you will find messages you have sent or received. Send a message to an initiative administrator to get started.',
        messageSent: 'Your message has been sent',
        loading: shared.loading,
        selectRecipients: 'Select recipients',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        numberOfMembersLabel: "You've got {0}",
        back: shared.back,
        done: 'Done',
        members: shared.members,
        followers: shared.followers,
        admins: shared.admins,
        sentMessages: 'Sent',
        showMore: 'Show more',
        showLess: 'Show less',
      },
      profile: {
        title: 'Profile',
        profileTooltip:
          'Once you follow an initiative or location, you apply for the interest list or respond to a discussion, others will see your profile and can contact you by sending a message through CrowdBuilding.',
        bio: 'Bio',
        bioEditHint:
          'Tell other users about yourself. A nicley composed bio helps others to understand whether this a match.',
        pictures: 'Pictures',
        media: 'Media',
        about: 'About',
        ageCategory: 'Age category',
        location: 'Location',
        numberOfAdults: 'Number of adults',
        numberOfChildren: 'Number of children',
        searchRegion: 'Search region',
        housingForm: 'Housing form',
        interests: 'Interests',
        fullName: 'Name and Last Name',
        nameErrorMessage: 'Please, specify your full name',
        yourRegions: 'Your search regions',
        selectRegion: 'Select a search region',
        yourHousingForms: 'Your housing forms',
        selectHousingForm: 'Select a housing form',
        yourInterests: 'Your interests',
        selectInterest: 'Select an interest',
        profileChangedSavedToast: 'Your profiles was updated.',
        imageUploadHint:
          'Upload photos that show who you are and how you want to live.',
        imageUploadAlert:
          'Make sure files are in .jpeg format and not larger than 500KB',
      },
      preferences: {
        title: 'Preferences',
        notificationSettings: 'Notification settings',
        livingSituationTitle: 'Living situation',
        livingSituationDescription:
          'All data from this field is NOT visible to other members but helps us to find you a better match.',
        housingType: 'Housing type',
        ownershipType: 'Desired ownership type',
        purchaseBudget: shared.purchaseBudget,
        rentalBudget: shared.rentalBudget,
        spaceSize: 'Space size',
        involvement: 'Involvement',
        houisngTypeOptions: {}, // Now fetched from database
        ownershipOptions: {}, // Now fetched from database
        spaceSizeOptions: {}, // Now fetched from database
        involvementOptions: {}, // Now fetched from database
        updateEmailsTitle: 'Update emails',
        updateEmailsSubtitle:
          'Receive two emails per month with a short update on plots, initiatives, stories and events.',
        importantNotificationsTitle: 'Important notifications',
        importantNotificationsSubtitle:
          'Important notifications about initiatives, housing forms and regions you follow. Think of new messages, comments in the Discussion tab and more.',
        monthlyNewsletterTitle: 'Monthly newsletter',
        monthlyNewsletterSubtitle:
          'Monthly the latest extensive news about CrowdBuilding, featured initiatives, opportunities, events and more.',
        crowdBuildingIntroductionTitle: 'CrowdBuilding introduction',
        crowdBuildingIntroductionSubtitle:
          'Email series about how you can use CrowdBuilding.',
        regionalNotificationsTitle: 'Provinces and municipalities I follow',
        regionalNotificationsSubtitle:
          'Updates about news, available subsidies, kaartenbak and popular discussions.',
        initiativesNotificationsTitle: 'Initiatives I follow',
        initiativesNotificationsSubtitle:
          'Updates about popular prikbord conversations, new events and posts from the initiative taker',
        houusingFormsNotificationsTitle: 'Living formats updates',
        houusingFormsNotificationsSubtitle:
          'Updates from the living formats you’re following. ',
        crowdBuildingUpdatesNotificationsTitle: 'Crowdbuilding updates',
        crowdBuildingUpdatesNotificationsSubtitle:
          'Platform updates such as new features.',
        crowdBuildingNewsNotificationsTitle: 'News emails from Crowdbuilding',
        crowdBuildingNewsNotificationsSubtitle:
          'Handpicked news that relate to the self building situation in the Netherlands.',
        notificationFrequencyOptions: notificationFrequencyTranslation,
      },
      followed: {
        title: 'Followed',
        initiatives: 'Initiatives',
        regions: 'Regions',
        housingForms: 'Housing forms',
        plots: 'Plots',
        unfollow: 'Unfollow',
        municipality: 'Municipality',
        province: 'Province',
        youFollowNoInitiatives: 'You follow no initiatives',
        youFollowNoRegions: 'You follow no regions',
        youFollowNoHousingForms: 'You follow no housing forms',
        youFollowNoPlots: 'You follow no plots',
      },
      initiative: {
        sideBar: {
          communityTools: 'Community tools',
          manage: 'Manage',
          about: 'About',
          messaging: 'Messaging',
          surveys: 'Surveys',
          pinBoard: 'Pin board',
          people: 'People',
        },
        common: {
          myInitiatives: 'My initiatives',
          loading: shared.loading,
          unnamedInitiative: 'Unnamed initiative',
        },
        home: {
          noInitiativesPlaceholder:
            'You don’t have any initiatives at the moment, start one ',
          startInitiative: 'Start an initiative',
          membersLabel: 'Members',
          followersLabel: 'Followers',
          articlesTitle: 'Useful articles',
          unnamedInitiative: 'Unnamed initiative',
          articlesSubtitle:
            'Don’t know where to start with your initiative or whether it’s for you? Our articles got you covered.',
          initiativeDraft: 'Draft',
        },
        view: {
          developmentForm: 'Development form',
          housingForms: shared.housingForms,
          targetGroups: 'Target groups',
          loading: shared.loading,
          unnamedInitiative: 'Unnamed initiative',
        },
        people: {
          loading: shared.loading,
          people: 'People',
          members: shared.members,
          followers: shared.followers,
          admins: shared.admins,
          requests: 'Requests',
          addedOn: 'Added on {0}',
          followingSince: 'Following since {0}',
          appliedOn: 'Applied on {0}',
          makeFollower: 'Move to followers',
          makeMember: 'Move to members',
          makeAdmin: 'Make an admin',
          removeFromProject: 'Remove from the initiative',
          participantStatusChanged: 'Participant status changed',
        },
        creation: {
          closeModalTitle: 'Confirm exist',
          closeModalContent:
            'Are you sure you want to leave?\nAll your changes will be saved.',
          createInitiative: 'Create an initiative',
          back: shared.back,
          next: 'Next',
          done: 'I am done',
          closeTheForm: 'Close this form',
          initiativePhaseNames: initiativePhaseNameTranslation,
          initiativePhaseDescriptions: initiativePhaseDescriptionTranslation,
          creationStepTitles: initiativeCreationStepTitleTranslation,
          creationStepDescriptions:
            initiativeCreationStepDescriptionTranslation,
          nameLabel: 'Initiative name',
          namePlaceholder: 'Name',
          sloganLabel: 'Initiative slogan',
          sloganPlaceholder: 'Slogan',
          imagesLabel: 'Select images',
          imagesSubtitle: 'You have to upload at least one image.',
          imagesInfoAlert:
            'Make sure files are in .jpeg format and not larger than 500KB.',
          contentLabel: 'Woondroom/Visie',
          contentPlaceholder: 'Describe your initative',
          developmentForm: 'Development form',
          targetGroups: 'Target groups',
          housingForms: shared.housingForms,
          interests: 'Interests',
          selectOne: 'Select one',
          selectOneOrMore: 'Select one or more',
          areYouLookingForMembers: 'Are you looking for members right now?',
          lookingForMembersTitle: 'Who do you look for? ',
          lookingForMembersSubtitle:
            'Think about what types of people, how many, etc.',
          lookingForMembersPlaceholder: 'Description of you target members',
          numberOfHomes: 'Number of homes',
          projectSize: 'Project size',
          purchaseBudget: shared.purchaseBudget,
          rentalBudget: shared.rentalBudget,
          numberOfHomesOptions: humberOfHomesTranslation,
          plotUnderOption: 'Plot under option?',
          notUnderOptionButInMind: 'Not yet but I have one in mind',
          address: 'Address',
          permit: 'Building permit',
          financingRequirementsConstruction:
            'Financing requirements construction',
          financingRequirementsPlanning: 'Financing requirements planning',
          kvkRegistration: 'Registered with KVK',
          contactPersonFirstName: 'Contact person first name',
          contactPersonLastName: 'Contact person last name',
          contactPersonEmailAdress: 'Contact person email address',
          contactPersonPhoneNumber: 'Contact person phone number',
          customAmenities: 'Custom amenities',
          addCustomAmenity: 'Add custom amenity',
          amenityNamePlaceholder: 'Amenity name',
          addOther: 'Other',
          save: 'Save',
          cancel: 'Cancel',
          customAmenityAdded: 'Amenity added',
        },
      },
    },
    plotRegistry: {
      welcome: {
        title: 'Welcome to the Kaartenbak',
        description:
          'Here is some text on what the kaartenbak is, and what advantages you have.',
        selectMunicipality: 'Choose your municipality/area',
        municipality: 'Municipality',
      },
      regionInfo: {
        stepsTitle:
          'Make sure you have completed the following steps before the registration process starts.',
        downloadDocument: 'Download document',
      },
      selectInitiative: {
        stepLabel: 'Step 1 of 3',
        title: 'Select the initiative you want to register for the kaartenbak',
        subtitle: 'You need to be logged in to select an initiative.',
        noInitiativesTitle: 'No initiatives found',
        noInitiativesDescription:
          'You are not an owner or admin of any initiative. Create an initiative first or request admin access.',
      },
      uploadDocuments: {
        stepLabel: 'Step 2 of 3',
        title: 'Upload the required documents',
        description:
          'These documents will be shared with the municipality of {municipalityName}. They determine the final approval for the kaartenbak.',
        warningBold: 'Note:',
        warningText:
          'After submitting these documents, it is no longer possible to make changes.',
        uploadButton: 'Upload here',
        consent:
          'I agree that my data will be shared with the municipality of {municipalityName}.',
        uploadSuccess: 'Document uploaded',
        deleteSuccess: 'Document removed',
      },
      confirmation: {
        congratulations: 'Congratulations!',
        title: 'The documents have been submitted!',
        subtitle:
          'You will receive a confirmation of the submission via e-mail.',
        step1Title: 'Interview with municipality',
        step1Description:
          'The municipality will invite your initiative for an interview in the short term.',
        step2Title: 'Correction and supplementation',
        step2Description:
          'The municipality may ask you to correct or supplement any incomplete information.',
        step3Title: 'Municipality decision',
        step3Description:
          'The municipality of {municipalityName} will assess whether your initiative is admitted to the kaartenbak.',
        step4Title: 'Kaartenbak admission',
        step4Description:
          'Upon approval, your initiative will officially be part of the kaartenbak of the municipality of {municipalityName} and you can apply for building plots.',
      },
    },
    error: {
      notFoundTitle: 'Oops! This page is not found.',
      notFoundMessage:
        'Maybe a typo in the address bar? Go back to our homepage or use the menu.',
      imageAlt: 'Page not found',
    },
  },
} as const

export default en
